(($) => {

	const openClass = 'open';

	const getMegamenu = megamenuId => {
		const $megamenu = $( `.megamenu[data-megamenu-id="${megamenuId}"]` );

		if( ! $megamenu ) throw new Error( `No megamenu exists in DOM with ID ${megamenuId}` );

		return $megamenu;
	}

	const isMegamenuOpen = megamenuId => getMegamenu( megamenuId ).hasClass( openClass );

	const openMegamenu = megamenuId => getMegamenu( megamenuId ).addClass( openClass );

	const closeMegamenu = megamenuId => getMegamenu( megamenuId ).removeClass( openClass );

	const closeAllMegamenus = () => $( '.megamenu' ).removeClass( openClass );

	// Triger opening/closing of megamenu
	$( 'a[data-megamenu-id]' ).click( event => {
		try {
			if( Foundation.MediaQuery.atLeast('xlarge') ) {
				const $target = $( event.target );
				const megamenuId = $target.data( 'megamenu-id' );

				if( ! megamenuId ) throw new Error( `No megamenu ID value for clicked element` );

				isMegamenuOpen( megamenuId ) ? closeMegamenu( megamenuId ) : openMegamenu( megamenuId );
			}
		} catch( error ) {
			console.log( error, event );
		}
	});

	// Close the megamenu if the user clicks on an irrelevant element
	$( document ).click( event => {
		try {
			const $relevantElements = $( '.megamenu, a[data-megamenu-id]' );
			const $target = $( event.target );
			const isRelevantElement = Boolean( $relevantElements.is( $target ) || $relevantElements.has( $target ).length );

			// If not relevant to megamenus, then close them all
			if( ! isRelevantElement ) closeAllMegamenus();
		} catch( error ) {
			console.log( error, event );
		}
	});

})(jQuery);



// WEBPACK FOOTER //
// ./js/components/megamenu.js